import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import s from './SeeAllLink.scss';
var SeeAllLink = function (_a) {
    var contentType = _a.contentType, type = _a.type, url = _a.url, className = _a.className;
    var t = useTranslation().t;
    return (React.createElement(BiLink, { className: classnames(s['see-all'], className), href: url, biData: {
            evid: BiEventType.SEE_ALL_CLICK,
        } }, t(["sidebar." + type + "." + contentType, "sidebar." + type])));
};
SeeAllLink.displayName = 'SeeAllLink';
export default SeeAllLink;
//# sourceMappingURL=SeeAllLink.js.map